import React from 'react';
import reactDOM from 'react-dom';
import { Provider } from 'react-redux';
import UrlHelper from 'foundation/url-helper';
import gtm from 'general/js/gtm';
import store from 'general/js/store';
import { CLOSE_TIMEOUT } from 'general/js/modal';
import historyController from 'general/js/history-controller';
import LivePlayerModal from './live-player-modal';
import { PLAYER_ID_QS_NAME } from './enums';

const LIVE_PLAYER_HISTORY_ID = 'live-player';

class LivePlayer {
    constructor() {
        this.root = document.createElement('div');
        this.root.id = 'live-player';
        document.body.appendChild(this.root);

        this.modal = null;
        this.state = {
            activePlayerId: null,
            isOpen: false,
        };

        this.init();
    }

    init() {
        this.applyPlayerFromQS();
        historyController.register(LIVE_PLAYER_HISTORY_ID, this.onHistoryChange);
    }

    onDestroy() {
        reactDOM.unmountComponentAtNode(this.root);
    }

    getUrlWithAppliedPlayerId(playerId) {
        return UrlHelper.getFullUrlWithAppliedParams(window.location, { [PLAYER_ID_QS_NAME]: playerId });
    }

    getPreparedPlayerIdValue(id) {
        return Number(id);
    }

    activate(playerId) {
        this.state.activePlayerId = playerId;
        this.state.isOpen = true;
        this.render();

        if (this.deactivatingTimeout) {
            clearTimeout(this.deactivatingTimeout);
            this.deactivatingTimeout = null;
        }
    }

    deactivate() {
        this.state.isOpen = false;
        this.render();

        this.deactivatingTimeout = setTimeout(() => {
            this.deactivatingTimeout = null;
            this.state.activePlayerId = null;
            this.render();
        }, CLOSE_TIMEOUT);
    }

    getPlayerIdFromQS() {
        let id = UrlHelper.getParamFromLocation(PLAYER_ID_QS_NAME, window.location);
        id = this.getPreparedPlayerIdValue(id);
        if (this.isValidPlayerId(id)) {
            return id;
        }
        return null;
    }

    isValidPlayerId(id) {
        if (!id) return false;
        return typeof id === 'number' && !Number.isNaN(id);
    }

    show = (id, title) => {
        id = this.getPreparedPlayerIdValue(id);

        if (!this.isValidPlayerId(id)) return;

        gtm.push('Player card', 'View Player Profile', `Player ID: ${id}`);

        historyController.pushState(LIVE_PLAYER_HISTORY_ID, title, this.getUrlWithAppliedPlayerId(id));
        this.activate(id);
    }

    applyPlayerFromQS() {
        const playerId = this.getPlayerIdFromQS();

        if (playerId) {
            if (playerId !== this.state.activePlayerId) {
                this.activate(playerId);
            }
        } else if (this.state.activePlayerId) {
            this.deactivate();
        }
    }

    onHistoryChange = () => {
        this.applyPlayerFromQS();
    }

    onClose = () => {
        const innerState = historyController.getState();
        let title = null;
        if (innerState && innerState.originalTitle) {
            title = innerState.originalTitle;
        }
        historyController.pushState(LIVE_PLAYER_HISTORY_ID, title, this.getUrlWithAppliedPlayerId(null));
        this.deactivate();
    }

    render() {
        reactDOM.render(
            <Provider store={store}>
                <LivePlayerModal
                    isOpen={this.state.isOpen}
                    playerId={this.state.activePlayerId}
                    onClose={this.onClose}/>
            </Provider>,
            this.root
        );
    }
}

export default new LivePlayer();
